define.alias("ember-composable-helpers/helpers/object-at", "preview-grid/helpers/object-at");